<template>
  <div class="chat-partner-icons">
    <img
      v-for="logo of logos"
      :key="logo.name"
      :src="logo.img"
      :alt="logo.name"
    >
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      logos: [
        {
          name: 'BT',
          img: require('@/assets/logos/suppliers/bt/colour.svg')
        },
        {
          name: 'PlusNet',
          img: require('@/assets/chat/provider-logos/plusnet.svg')
        },
        {
          name: 'Daisy',
          img: require('@/assets/logos/suppliers/daisy/colour.svg')
        },
        {
          name: 'TalkTalk',
          img: require('@/assets/chat/provider-logos/talktalk.svg')
        },
        {
          name: 'Focus',
          img: require('@/assets/chat/provider-logos/focus.svg')
        },
        {
          name: 'EE',
          img: require('@/assets/chat/provider-logos/ee.svg')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-partner-icons {
  width: 100%;
  height: 45px;
  margin-top: $spacing-4;
  display: flex;
  justify-content: space-between;

  img {
    margin: 0 $spacing-6;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: $screen-md) {
    flex-wrap: wrap;
    justify-content: space-around;
    height: auto;

    img {
      max-width: 50%;
      margin: $spacing-8 0;
    }
  }
}
</style>
